<template lang="pug">
Transition(name='modal-fade')
  BaseModal.program-modal(
    v-if="isOpen"
    @backdropClick="$emit( 'close' )"
  )
    template(v-slot:header)
      .header-container
        b Currently Editing:
        .header-title {{ headerText }}
      IconClose(class="icon-close" @click="$emit( 'close' )")
    template(v-slot:body)
      template(v-if="!selectedPathway")
        .pathways-container(v-if="pathways")
          .list-item(v-for="pathway in pathways" @click="showEditPathwayModal(pathway)")
            p.program-name {{ pathway.name }}
            IconChevron.icon-chevron
          //- button.add-pathway-button(@click="showAddPathwayModal")
          //-   .plus-sign
      .program-of-study(v-if="selectedPathway")
        .top
          button.go-back(@click="goBack")
            IconChevron.icon-chevron(direction="left")
            p.go-back-text Back to programs
        .middle
          edit-pathway(
            v-if="selectedPathway"
            :editPathway="selectedPathway"
            @remove-school="removeSchool"
          )
          //- add-pathway(
          //-   v-if="selectedPathway && newPathway"
          //-   :industrySector="selectedPathway.industrySector"
          //-   @new-pathway-saved="closeAddPathwayModal"
          //- )
</template>

<script>
import BaseModal from '@/components/BaseModal';
import IconClose from '@/components/IconClose';
import IconDownload from '@/components/IconDownload';
import IconChevron from '@/components/IconChevron';
import DownloadLink from '@/components/DownloadLink';
import CtePathwayPreview from '@/components/CtePathwayPreview';
import EditPathway from '@/components/pathway/EditPathway';
// import AddPathway from '@/components/pathway/AddPathway';

export default {

  name       : 'edit-sector-modal',
  components : {
    BaseModal,
    IconClose,
    IconDownload,
    IconChevron,
    DownloadLink,
    CtePathwayPreview,
    EditPathway,
    // AddPathway
  },
  props : {
    isOpen   : Boolean,
    sector   : Object,
    pathways : Array,
  },

  data() {
    return {
      selectedPathway : null,
    //   newPathway      : false
    };
  },

  computed : {
    headerText() {
      if ( !this.sector ) return '';

      if ( this.selectedPathway && this.selectedPathway.name ) {
        return `${this.sector.name} Program of Study -> ${this.selectedPathway.name}`;
      }

      if ( this.selectedPathway ) {
        return `${this.sector.name} Program of Study -> New Program`;
      }

      return `${this.sector.name} Programs of Study`;
    },
  },

  watch : {
    // Reset selectedPathway whenever the modal closes.
    isOpen : {
      immediate : true,
      handler( newIsOpen ) {
        if ( !newIsOpen ) {
          this.selectedPathway = null;
        }
      },
    },
  },

  methods : {
    // showAddPathwayModal() {
    //   this.newPathway = true;
    //   this.selectedPathway = {
    //     industrySector : this.sector.name,
    //   };
    // },

    closeAddPathwayModal() {
      this.newPathway = false;
      this.selectedPathway = null;
    },

    showEditPathwayModal( pathway ) {
      this.selectedPathway = pathway;
    },

    removeSchool( editPathwayID, schoolName ) {
      this.$emit( 'remove-school', editPathwayID, schoolName );
    },

    goBack() {
      this.selectedPathway = null;
      // this.newPathway = false;
    },

  },
};

</script>

<style lang="scss" scoped>
.add-pathway-button {
    display: flex;
    justify-content: center;

    width: 100%;
    margin-top: 1.5rem;
    background-color: $primary;

    border: none;
    border-radius: 5px;
    cursor: pointer;
}

.plus-sign {
    height: 50px;
    width: 50px;
    position: relative;

    &::before,
    &::after {
        content: " ";
        position: absolute;
        top: 50%;
        left: 50%;
        height: 30px;
        width: 4px;
        border-radius: 2px;
        background-color: white;
    }

    &::before {
        transform: translate(-50%, -50%);
    }

    &::after {
        transform: translate(-50%, -50%) rotate(90deg);
    }
}

// Animates such that the backdrop fades in and the modal content slides in from the bottom
.modal-fade-enter,
.modal-fade-leave-to {
    opacity: 0;

    &::v-deep .modal {
        transform: translateY(50vh);
    }
}

.modal-fade-enter-active,
.modal-fade-leave-active {
    transition: opacity 0.3s ease;

    &::v-deep .modal {
        transition: transform 0.3s ease;
    }
}

.program-modal {
    z-index: 1;
    max-height: 100vh;

    &::v-deep .modal {
        max-height: 90vh;
        width: 90%;
        min-height: 400px;
        display: flex;
        flex-direction: column;

        @include sm {
            width: 600px;
        }

        .modal-header {
            background-color: rgb(0, 141, 63);
            padding: 20px;
            padding-bottom: 15px;

            .header-title {
                margin-top: 5px;
                width: 70%;
                font-size: 21px;
            }

            .icon-close {
                position: absolute;
                top: 15px;
                right: 15px;
                color: white;
            }
        }

        .modal-body {
            padding: 20px;
            flex: 1;
            display: flex;
            flex-direction: column;
            overflow: auto;

            .list-item {
                display: flex;
                justify-content: space-between;
                align-items: center;
                cursor: pointer;

                &:not(:last-child) {
                    margin-bottom: 10px;
                }

                .program-name {
                    font-weight: 500;
                    font-size: 18px;
                }

                .icon-chevron {
                    color: #4f4f4f;
                    width: 10px;
                }
            }

            .program-of-study {
                flex: 1;
                display: flex;
                flex-direction: column;

                .top {
                    display: flex;
                    justify-content: space-between;

                    /* NOTE(Johnny): I know semantically its better to render the html as a button rather than have it be a div that behaves like a button, but is it worth it to \
                    have a button in the styling and then undo all the styling?
                    */
                    button {
                        all: unset;
                    }

                    .go-back {
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        gap: 10px;

                        .go-back-text {
                            font-size: 18px;
                        }

                        .icon-chevron {
                            margin-top: 2px;
                            width: 8px;
                        }
                    }

                    .download-button {
                        display: flex;
                        align-items: center;
                        color: #1c4587;
                        cursor: pointer;

                        .icon-download {
                            width: 14px;
                            margin-right: 10px;
                        }

                        .button-text {
                            font-weight: 500;
                        }
                    }
                }

                .middle {
                    flex: 1 1 auto;
                    margin-top: 1rem;
                    overflow: auto;

                    .preview {
                        max-width: 100%;
                        height: auto;
                    }
                }

                .bottom {
                    margin-top: auto;
                }
            }
        }
    }
}
</style>
